import React from 'react';
import {
  AlertTriangle,
  BarChart3,
  ClipboardList,
  FileText,
  HelpCircle,
  Key,
  LucideIcon,
  Plug,
  Users,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  checklist: ClipboardList,
  'help-circle': HelpCircle,
  'plug-connected': Plug,
  'file-text': FileText,
  'chart-bar': BarChart3,
  users: Users,
  'alert-triangle': AlertTriangle,
  key: Key,
};

type Props = {
  name: string;
  color?: string;
  size?: number;
  className?: string;
};

export const ThemeIcon: React.FC<Props> = ({
  name,
  color = 'currentColor',
  size = 14,
  className,
}) => {
  const Icon = ICON_MAP[name] || BarChart3;
  return <Icon size={size} color={color} strokeWidth={2.25} className={className} aria-hidden />;
};
